import { useState } from 'react'
import { router } from '@inertiajs/react'
import { Loader2 } from 'lucide-react'
import type { AvailablePlan, CurrentPlan } from '../types'

interface Props {
  workerId: string
  currentPlan: CurrentPlan
  availablePlans: AvailablePlan[]
}

export default function PlanChangeSection({ workerId, currentPlan, availablePlans }: Props) {
  const [selectedSlug, setSelectedSlug] = useState(currentPlan?.slug ?? '')
  const [saving, setSaving] = useState(false)

  const isDirty = selectedSlug !== (currentPlan?.slug ?? '')

  const handleSave = () => {
    if (!isDirty) return
    setSaving(true)
    router.patch(
      `/cc/digital_workers/${workerId}/update_plan`,
      { plan_slug: selectedSlug },
      { preserveScroll: true, onFinish: () => setSaving(false) }
    )
  }

  return (
    <div className="flex items-center gap-1.5 mt-1.5">
      <span className="text-[10px] text-muted-foreground whitespace-nowrap">Plano:</span>
      <select
        value={selectedSlug}
        onChange={(e) => setSelectedSlug(e.target.value)}
        disabled={saving}
        className="text-[10px] border border-border rounded px-1.5 py-0.5 bg-background text-foreground focus:outline-none focus:ring-1 focus:ring-ring min-w-0"
      >
        {!currentPlan && <option value="">Sem plano</option>}
        {availablePlans.map((p) => (
          <option key={p.slug} value={p.slug}>{p.name}</option>
        ))}
      </select>
      {isDirty && (
        <button
          onClick={handleSave}
          disabled={saving}
          className="text-[10px] font-medium text-violet-600 dark:text-violet-400 hover:text-violet-700 dark:hover:text-violet-300 disabled:opacity-50"
        >
          {saving ? <Loader2 className="h-3 w-3 animate-spin" /> : 'Salvar'}
        </button>
      )}
    </div>
  )
}
